<div class="header">
  <div class="color-navy-900 text-size_xl font-semibold">Company Name</div>
  <div class="flex gap-2 items-center">
    <app-simple-button (click)="openContactsSidebar()">Add Contact</app-simple-button>
    <app-simple-button (click)="openInvitationsSidebar()">Send Invite</app-simple-button>
  </div>
</div>
<app-loading-bar [hidden]="!(loading() && contactGroups()?.length !== 0)"></app-loading-bar>

<section class="content">
  @for (contactGroup of contactGroups(); track contactGroup.id; let index = $index) {
    <app-expansion-panel-v2 [expanded]="isExpanded()[contactGroup.id]" #panel>
      <div header-row (click)="togglePanelExpansion(contactGroup.id)" class="contacts-row company">
        <div class="initials">{{ contactGroup.initials }}</div>
        <div>
          @if (isGroupNameEdit()[contactGroup.id]) {
            <app-floating-input
              (click)="$event.stopPropagation()"
              [name]="'group_name' + index"
              placeholder="Company Name"
              [ngModel]="groupNames()[contactGroup.id]"
              (ngModelChange)="onGroupNameChange($event, contactGroup)"
              iconClass="icon-input-box-checked"
              (iconClick)="saveGroupName($event, contactGroup)"
              (enterPressed)="saveGroupName($event, contactGroup)"
            >
            </app-floating-input>
          } @else {
            <div class="font-semibold text-navy-900 text-size_xxl">{{ contactGroup.name }}</div>
          }
        </div>
        <app-options-list-simple
          [actions]="companyOptions()"
          (optionSelected)="onCompanyOptionSelected($event, contactGroup)"
        ></app-options-list-simple>
        <div
          class="icon icon-participants-circle-bg"
          [ngClass]="{
            'text-navy-900': panel.isExpanded,
          }"
        ></div>
      </div>

      <div content-row>
        @for (contact of contactGroup.contacts; track contact.id) {
          <div class="contacts-row contact">
            <div class="initials">{{ contact.initials }}</div>
            <div>
              <div class="font-bold text-size_xl text-navy-900">{{ contact.first_name }} {{ contact.last_name }}</div>
              <div class="font-normal text-size_xl text-navy-900">{{ contact.title }}</div>
            </div>
            <app-options-list-simple
              [actions]="contactOptions()"
              (optionSelected)="onContactOptionSelected($event, contact, contactGroup)"
            ></app-options-list-simple>
            <div (click)="sendMessageTo(contact)" class="icon icon-messages hover:text-navy-700"></div>
            <div class="flex gap-1 items-center flex-nowrap">
              <span class="icon icon-contact text-navy-700"></span>
              <span class="font-semibold">{{ contact.phone | phone: 'No Phone Number' }}</span>
            </div>
            <div class="flex gap-1 items-center flex-nowrap">
              <span class="icon icon-email-circle text-navy-700"></span>
              <span class="font-semibold">{{ contact.email }}</span>
            </div>
            <div class="flex gap-1 items-center flex-nowrap">
              <span class="icon icon-location-circle text-navy-500"></span>
              <span class="font-semibold">
                {{ contact.formattedAddress }}
              </span>
            </div>
          </div>
        } @empty {
          <div class="contacts-row contact no-contacts">No contacts in this company yet.</div>
        }
      </div>
    </app-expansion-panel-v2>
  } @empty {
    @if (loading()) {
      <app-page-loading></app-page-loading>
    } @else {
      <app-splash-screen title="There are no contacts yet." subTitle="Get started by adding a new contact.">
        <app-simple-button size="large" (click)="openContactsSidebar()">Add Contact</app-simple-button>
      </app-splash-screen>
    }
  }
</section>
